import * as approvalFacadeImpl from "./approvalFacadeImpl";
import * as associatedFiles from "./associatedFiles";
import * as basicData from "./basicData";
import * as cabinAdvanceFacadeImpl from "./cabinAdvanceFacadeImpl";
import * as cabinAdvanceMaster from "./cabinAdvanceMaster";
import * as cabinMasterFacadeImpl from "./cabinMasterFacadeImpl";
import * as cabinMasterFactoryScattered from "./cabinMasterFactoryScattered";
import * as cabinMasterFactoryWhole from "./cabinMasterFactoryWhole";
import * as cabinMasterSelfScattered from "./cabinMasterSelfScattered";
import * as cabinMasterSelfWhole from "./cabinMasterSelfWhole";
import * as cashFlow from "./cashFlow";
import * as cbsPaymentCallbackNoticeFacadeImpl from "./cbsPaymentCallbackNoticeFacadeImpl";
import * as costRequest from "./costRequest";
import * as costType from "./costType";
import * as customsClearance from "./customsClearance";
import * as customsClearanceDetails from "./customsClearanceDetails";
import * as customsDeclarationApplyDetails from "./customsDeclarationApplyDetails";
import * as customsDeclarationContract from "./customsDeclarationContract";
import * as customsDeclarationDetails from "./customsDeclarationDetails";
import * as customsDeclarationItem from "./customsDeclarationItem";
import * as customsDeclarationMaster from "./customsDeclarationMaster";
import * as declareContract from "./declareContract";
import * as exportDeclaration from "./exportDeclaration";
import * as logisticsChannel from "./logisticsChannel";
import * as logisticsChannelFacadeImpl from "./logisticsChannelFacadeImpl";
import * as logisticsChannelLimit from "./logisticsChannelLimit";
import * as logisticsChannelLogisticsGroup from "./logisticsChannelLogisticsGroup";
import * as logisticsChannelMapping from "./logisticsChannelMapping";
import * as logisticsChannelPlatform from "./logisticsChannelPlatform";
import * as logisticsChannelPrice from "./logisticsChannelPrice";
import * as logisticsChannelTob from "./logisticsChannelTob";
import * as logisticsChannelWarehouse from "./logisticsChannelWarehouse";
import * as logisticsChannelZone from "./logisticsChannelZone";
import * as logisticsMatchFacadeImpl from "./logisticsMatchFacadeImpl";
import * as logisticsPlatformFacadeImpl from "./logisticsPlatformFacadeImpl";
import * as logisticsPriceFacadeImpl from "./logisticsPriceFacadeImpl";
import * as logisticsProvider from "./logisticsProvider";
import * as logisticsProviderTob from "./logisticsProviderTob";
import * as logisticsQuotation from "./logisticsQuotation";
import * as logisticsQuotationDetailTob from "./logisticsQuotationDetailTob";
import * as logisticsQuotationInfo from "./logisticsQuotationInfo";
import * as logisticsQuotationSurchargeFormula from "./logisticsQuotationSurchargeFormula";
import * as logisticsQuotationSurchargeInfo from "./logisticsQuotationSurchargeInfo";
import * as logisticsQuotationSurchargeRule from "./logisticsQuotationSurchargeRule";
import * as logisticsQuotationTob from "./logisticsQuotationTob";
import * as logisticsQuotationZone from "./logisticsQuotationZone";
import * as logisticsTariffThreshold from "./logisticsTariffThreshold";
import * as paymentMaster from "./paymentMaster";
import * as platformLogistics from "./platformLogistics";
import * as skuQuote from "./skuQuote";
import * as startPort from "./startPort";
import * as stockOccupyDetail from "./stockOccupyDetail";
import * as stockOccupyFacadeImpl from "./stockOccupyFacadeImpl";
import * as tariffThresholdFacadeImpl from "./tariffThresholdFacadeImpl";
import * as taxRefundMatching from "./taxRefundMatching";
import * as test from "./test";
import * as transportFinanceDetail from "./transportFinanceDetail";
import * as transportMaster from "./transportMaster";
import * as transportToDetailFacadeImpl from "./transportToDetailFacadeImpl";
import * as zoneTemplate from "./zoneTemplate";
import * as zoneTemplateDetail from "./zoneTemplateDetail";

export const tms = {
  approvalFacadeImpl,
  associatedFiles,
  basicData,
  cabinAdvanceFacadeImpl,
  cabinAdvanceMaster,
  cabinMasterFacadeImpl,
  cabinMasterFactoryScattered,
  cabinMasterFactoryWhole,
  cabinMasterSelfScattered,
  cabinMasterSelfWhole,
  cashFlow,
  cbsPaymentCallbackNoticeFacadeImpl,
  costRequest,
  costType,
  customsClearance,
  customsClearanceDetails,
  customsDeclarationApplyDetails,
  customsDeclarationContract,
  customsDeclarationDetails,
  customsDeclarationItem,
  customsDeclarationMaster,
  declareContract,
  exportDeclaration,
  logisticsChannel,
  logisticsChannelFacadeImpl,
  logisticsChannelLimit,
  logisticsChannelLogisticsGroup,
  logisticsChannelMapping,
  logisticsChannelPlatform,
  logisticsChannelPrice,
  logisticsChannelTob,
  logisticsChannelWarehouse,
  logisticsChannelZone,
  logisticsMatchFacadeImpl,
  logisticsPlatformFacadeImpl,
  logisticsPriceFacadeImpl,
  logisticsProvider,
  logisticsProviderTob,
  logisticsQuotation,
  logisticsQuotationDetailTob,
  logisticsQuotationInfo,
  logisticsQuotationSurchargeFormula,
  logisticsQuotationSurchargeInfo,
  logisticsQuotationSurchargeRule,
  logisticsQuotationTob,
  logisticsQuotationZone,
  logisticsTariffThreshold,
  paymentMaster,
  platformLogistics,
  skuQuote,
  startPort,
  stockOccupyDetail,
  stockOccupyFacadeImpl,
  tariffThresholdFacadeImpl,
  taxRefundMatching,
  test,
  transportFinanceDetail,
  transportMaster,
  transportToDetailFacadeImpl,
  zoneTemplate,
  zoneTemplateDetail,
};
